import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { red, blue, blueGrey, orange } from '@material-ui/core/colors';
import Grow from '@material-ui/core/Grow';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = (theme) => ({
	root: {
		padding: theme.spacing.unit * 2,
		color: 'white',
		fontSize: 22,
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginTop: theme.spacing.unit * 2
	},
	text: {
		lineHeight: '1.2em',
		position: 'relative'
	},
	progress: {
		marginRight: theme.spacing.unit,
		fontSize: 15,
		color: 'white',
		display: 'flex'
	},
	progressSvg: {
		flex: 1
	},
	icon: {
		color: 'white',
		marginRight: theme.spacing.unit,
		fontSize: 22,
		position: 'absolute',
		left: -30,
		display: 'flex',
		alignItems: 'center',
		height: '100%'
	},
	alert: {
		background: red[500],
	},
	recording: {
		background: red[600],
	},
	info: {
		background: blueGrey[500],
	},
	correct: {
		background: blue[500],
	},
	incorrect: {
		background: red[500],
	},
	highlight: {
		background: orange.A400
	}
});

class Feedback extends Component {
	render() {
		const { classes, visible, style, icon, text, loading, answered } = this.props;

		return (
			<Grow in={visible} timeout={answered ? 0 : 300}>
				<div className={classNames(classes.root, style && classes[style])}>
					{loading && <CircularProgress className={classes.progress} size={18} classes={{ svg: classes.progressSvg }} />}
					<Typography variant="subheading" color="inherit" className={classes.text}>
						{icon && <i className={classNames('fa', icon, classes.icon)} />}
						{text || '&nbsp;'}
					</Typography>
				</div>
			</Grow>
		);
	}
}

Feedback.propTypes = {
	classes: PropTypes.object.isRequired,
	visible: PropTypes.bool,
	loading: PropTypes.bool,
	answered: PropTypes.bool.isRequired,
	style: PropTypes.string,
	icon: PropTypes.string,
	text: PropTypes.string,
};

Feedback.defaultProps = {
	visible: false,
	style: undefined,
	icon: undefined,
	text: undefined,
	loading: false
};

function mapStateToProps({ exercise: { currentItem }, feedback }) {
	const currentFeedback = feedback[currentItem];
	if (!currentFeedback) return {};

	const { visible, type, loading, messageId } = currentFeedback;

	const currentMessageType = window.loader.exercises.common.audioanalysis.MESSAGE_TYPES[type];
	if (!currentMessageType) return {};

	const { style, text, icon } = currentMessageType;

	return {
		visible,
		style,
		icon,
		text: text || window.loader.exercises.common.audioanalysis.getAudioQualityTextByMessageId(messageId),
		loading
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(Feedback);
